// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import elementUI from 'element-ui'
import echarts from 'echarts'
import VueKeepScrollPosition from 'vue-keep-scroll-position'
import i18n from './locale'
import store from 'zmfront-framework/src/store'
import Util from 'zmfront-framework/src/utils/util'
import omsRouter from './router/omsRouter';
import tmsRouter from './router/tmsRouter';
import plTable from 'pl-table'
import '../node_modules/echarts/map/js/world.js'


import zmGlobalService from './utils/zmGlobalService'
import zmAudioService from './utils/zmAudioService'
import zmFormulaHelperService from './utils/zmFormulaHelperService'
import zmPackingFeeService from './utils/zmPackingFeeService'
import zmPackingFee2Service from './utils/zmPackingFee2Service'
import zmPremiumFeeService from './utils/zmPremiumFeeService'
import zmQueryRemoteFeeService from './utils/zmQueryRemoteFeeService'
import sockedService from './utils/socked'
import zmWeigCollectService from './utils/zmWeigCollectService'
import zmFlipRuleService from './utils/zmFlipRuleService'
import zmCarryRuleService from './utils/zmCarryRuleService'
import zmTranslate from './utils/baiduTranslate'
import zmMessage from './components/ZmMessage'

import zmfilter from './utils/zmFilter'


import 'zmfront-framework/src/directives/directives'
import axios from 'axios'
import zmfrontFramework from 'zmfront-framework'

import 'pl-table/themes/index.css'
// import 'pl-table/themes/plTableStyle.css'
import "./assets/css/gla.css"
// 样式文件
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import 'zmfront-framework/src/assets/css/common.css'
import '../src/assets/css/tmsCommon.css'

import '../src/assets/css/menuIcon.css'
// import './package/drawer/drawer.css'
import 'zmfront-framework/src/package/drawer/drawer.css'

//组件
import importLog from './components/ImportLog'
import zmImpBtn from './components/ZmImpBtn'
import zmDialog from './components/ZmDialog'
import zmCallTable from './components/zmCallTable'
import zmNumInput from './components/ZmNumInput'
import zmBaseExport from './components/ZmBaseExport'
import elFormItem from './components/ElFormItem'

import custcollectConfirm from './pages/bms/cashier/custcollect_confirm.vue'
import custcollectConfirms from './pages/bms/cashier/custcollect_confirm2.vue'
// import ElDrawer from './package/drawer'
import ZmTable from 'zmfront-framework/src/components/CommonTable/ZmTable'
import ZmTableGrid from 'zmfront-framework/src/components/CommonTable/ZmTableGrid'

//JSON字符串格式化
import JsonViewer from 'vue-json-viewer'


// 针对老版本浏览器没有Promise对象
import Es6Promise from 'es6-promise'
// 引入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
// require styles 富文本编辑器对应的样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import moment from 'moment'
import Zmfilter from "zmfront-framework/src/utils/zmfilters";
Es6Promise.polyfill();

Vue.use(JsonViewer)

Vue.use(VueKeepScrollPosition);
Vue.use(plTable);
Vue.use(elementUI, {
  size: "mini",
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(zmfrontFramework);
Vue.use(VueQuillEditor)
console.log(plTable)
Vue.component('import-log',importLog);
Vue.component('zm-imp-btn',zmImpBtn);
Vue.component('zm-dialog',zmDialog);
Vue.component('zm-call-table',zmCallTable);
Vue.component('zm-num-input',zmNumInput);
Vue.component('zm-base-export',zmBaseExport);
Vue.component('el-form-item',elFormItem);

Vue.component('custcollect_confirm',custcollectConfirm);
Vue.component('custcollect_confirms',custcollectConfirms);
// Vue.component('el-drawer',ElDrawer);
Vue.component('zm-table',ZmTable);
Vue.component('zm-table-grid',ZmTableGrid);


Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.$tmsglobal = zmGlobalService;
Vue.prototype.$zmaudio = zmAudioService;
Vue.prototype.$packingfee = zmPackingFeeService;
Vue.prototype.$packingfee2 = zmPackingFee2Service;
Vue.prototype.$zmformulahelper = zmFormulaHelperService;
Vue.prototype.$zmPremiumFee = zmPremiumFeeService;
Vue.prototype.$zmQueryRemoteFee = zmQueryRemoteFeeService;
Vue.prototype.$sockedService = sockedService;
Vue.prototype.$zmWeigCollect = zmWeigCollectService;
Vue.prototype.$zmFlipRuleService = zmFlipRuleService;
Vue.prototype.$zmCarryRuleService = zmCarryRuleService;
Vue.prototype.$zmTranslate = zmTranslate;
Vue.prototype.$zmMessage = zmMessage.install;
Vue.prototype.$store = store;


//注册全局过滤器
for(let key in zmfilter){
    Vue.filter(key,zmfilter[key])
}



/*
for(let key in Zmfilter){
    Vue.filter(key,Zmfilter[key])
}
*/




//跳转路由过滤，未配置页面跳转404页面
const mainto = function (to,next) {
    if (to.matched.length === 0) {
        next({ path: '/404page' });
    } else {
        let tagsMenu = store.getters.tagsMenu;

        if(tagsMenu != null && tagsMenu.length >= 15){
            //判断是否已存在页签
            let toflag = false;
            for (let i = 0;i<tagsMenu.length;i++) {
                if (tagsMenu[i].meta.tabName === to.meta.tabName) {
                    toflag = true;
                    break;
                }
            }
            if(toflag){
                next();
            }else{
                Util.show(i18n.t("您已打开过多的窗口，请关闭暂时不用的窗口后重新打开"),1);
            }
        }else {
            next(); //如果匹配到正确跳转
        }
    }
}

const maintologin = function (next) {
    let loginPath = null;
    // console.log(process.env.PORT_LOGIN_PATH)
    if(process.env.PORT_LOGIN_PATH()){
        let port = window.location.port;
        let portLogins = process.env.PORT_LOGIN_PATH().split(",");
        if(portLogins && portLogins.length > 0){
            for(let i = 0;i<portLogins.length;i++){
                let portpath = portLogins[i].split(":");
                if(portpath && portpath.length === 2){
                    if(portpath[0] == port){
                        loginPath = portpath[1];
                        break;
                    }
                }
            }
        }
    }
    if(!loginPath){
        loginPath = process.env.LOGIN_PATH() ? process.env.LOGIN_PATH() : '/login';
    }
    console.log(loginPath)
    next({ path: loginPath });
}



//路由过滤和菜单加载
const whiteList = ['login','ddslogin','gyelogin','omslogin','outtrack','versioninfo','resetPassword'];
const checkVersionList = ['login','ddslogin','gyelogin','omslogin','resetPassword'];
const routerFilterFun = function (to,next) {
    if(to.path == '/tail/log'){
        location.href = process.env.BASE_URL() +'tail/log';
    }else{
        if (whiteList.indexOf(to.name) !== -1) {
            // next();
            mainto(to,next);
        } else {
            if (sessionStorage.getItem("token")) {
                if (store.getters.menuList !== null) {
                    // next()
                    mainto(to,next);
                } else {
                    store.dispatch("menuSet","bas/menu/find").then(() => {
                        // 动态添加可访问路由表
                        let sysType = Util.get("sysType");
                        if('oms' == sysType){
                            router.addRoutes(omsRouter.getRouters());
                        }else{
                            router.addRoutes(tmsRouter.getRouters());
                        }
                        next({ ...to, replace: true })
                    }).catch((data) => {
                        maintologin(next);
                        // Util.show("您没有菜单权限，联系管理员配置权限！", 2);
                    })
                }
            } else {
                maintologin(next);
                /*let loginPath = null;
                // console.log(process.env.PORT_LOGIN_PATH)
                if(process.env.PORT_LOGIN_PATH()){
                    let port = window.location.port;
                    let portLogins = process.env.PORT_LOGIN_PATH().split(",");
                    if(portLogins && portLogins.length > 0){
                        for(let i = 0;i<portLogins.length;i++){
                            let portpath = portLogins[i].split(":");
                            if(portpath && portpath.length === 2){
                                if(portpath[0] == port){
                                    loginPath = portpath[1];
                                    break;
                                }
                            }
                        }
                    }
                }
                if(!loginPath){
                    loginPath = process.env.LOGIN_PATH() ? process.env.LOGIN_PATH() : '/login';
                }
                console.log(loginPath)
                next({ path: loginPath });*/
            }
        }
    }

};




router.beforeEach((to, from, next) => {
    if (checkVersionList.indexOf(to.name) === -1) {
        routerFilterFun(to,next);
    }else{
        // console.log('进入登录页面 检测当前版本！');
        //开发环境不走版本监测控制
        if(process.env.NODE_ENV == 'development'){
            routerFilterFun(to,next);
        }else{
            let protocolStr = document.location.protocol == 'https:' ? 'https' : 'http'
            let versionUrl =protocolStr + '://'+window.location.host+'/static/version.json?_=' + Math.random();
            //版本检测控制
            axios.get(versionUrl).then(response => {
                if (200 == response.status) {
                    if (process.env.VERSION !== response.data.version) {
                        Util.alert(i18n.t('系统版本有更新，点击确认加载最新，或按【CTRL + F5】！'), i18n.t('系统提示'), 1).then(() => {
                            window.location.reload(true);
                        });
                        return;
                    }
                    routerFilterFun(to,next);
                }
            }).catch(err => {
                next(err);
            });
        }
    }


});

router.onError((error) => {
    if(process.env.NODE_ENV == 'development'){
        Util.show(i18n.t("Main.网络连接中断！"),2);
    }else{
        let protocolStr = document.location.protocol == 'https:' ? 'https' : 'http'
        let versionUrl = protocolStr + '://'+window.location.host+'/static/version.json?_=' + Math.random();
        axios.get(versionUrl).then(response => {
            if (200 == response.status) {
                if (process.env.VERSION !== response.data.version) {
                    Util.alert(i18n.t('系统版本有更新，点击确认加载最新，或按【CTRL + F5】！'), i18n.t('系统提示'), 1).then(() => {
                        window.location.reload(true);
                    });
                    return;
                }
            }
        }).catch(err => {
            Util.show(i18n.t("Main.网络连接中断！"),2);
        });
    }


    // Util.show("网络连接中断！",2);
});
Vue.directive('waterMarker', {
    inserted(el, binding) {
      let {userName} = JSON.parse(sessionStorage.getItem("userInfo"))
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 200;
      canvas.height = 100;
      ctx.font = '20px Arial';
      ctx.fillStyle = 'rgba(150, 150, 150, 0.1)';
      ctx.rotate(-15 * Math.PI / 180);
      ctx.fillText(userName || '水印', 10, 50)
      const watermarkDiv = document.createElement('div');
      // watermarkDiv.style.position = 'fixed';
      // watermarkDiv.style.top = 0;
      // watermarkDiv.style.left = 0;
      // watermarkDiv.style.pointerEvents = 'none';
      // watermarkDiv.style.zIndex = 9999;
      // watermarkDiv.style.width = '100%';
      // watermarkDiv.style.height = '100%';
      // watermarkDiv.style.background = `url('${canvas.toDataURL("image/png")}') left top repeat`;
      // watermarkDiv.style.backgroundSize = '200px 100px';
      const styleStr = `
              position:fixed;
              top:0;
              left:0;
              width:100vw;
              height:100vh;
              z-index:9999;
              pointer-events:none;
              background-repeat:repeat;
              mix-blend-mode: multiply;
              background-image:url('${canvas.toDataURL("image/png")}')`;
      watermarkDiv.setAttribute('style', styleStr);
      watermarkDiv.classList.add('watermark')
      document.body.appendChild(watermarkDiv);
      // 创建MutationObserver来监测body元素的子节点变化
      const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                  // if (mutation.removedNodes.length > 0) {
                  //     mutation.removedNodes.forEach((node) => {
                  //         if (node === watermarkDiv) {
                  //             document.body.appendChild(watermarkDiv);
                  //         }
                  //     });
                  // }
                  if (mutation.type === 'attributes') {
                    // console.log(`属性 ${mutation.attributeName} 发生变化`);
                    document.body.appendChild(watermarkDiv);
                  }
              });
              const wmInstance = document.querySelector('.watermark');
              if ((wmInstance && wmInstance.getAttribute('style') !== styleStr) || !wmInstance) {
                  //如果标签在，只修改了属性，重新赋值属性
                  if (wmInstance) {
                      // 避免一直触发
                      // observer.disconnect();
                      // console.log('水印属性修改了');
                      wmInstance.setAttribute('style', styleStr);
                  } else {
                      /* 此处根据用户登录状态，判断是否终止监听，避免用户退出后登录页面仍然有水印 */
                      if (username) {
                          //标签被移除，重新添加标签
                          // console.log('水印标签被移除了');
                          document.body.appendChild(watermarkDiv)
                      } else {
                          observer.disconnect();
                      }
                  }
              }
      });
      observer.observe(document.body, {attributes: true,childList: true ,subtree: true,});
    },
  });
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>',
  data() {
    return {
      app: {
        settings: {
          asideFolded: false
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/main.js